import type { PropsOf } from "@chakra-ui/system";
import { chakra } from "@chakra-ui/system";
import { useMediaQuery } from "@chakra-ui/react";

// `chakra("svg")` instead of `chakra.svg`: @chakra-ui/system 2.6.x
// dropped the direct SVG accessor from HTMLChakraComponents, but the
// factory-call form still constructs the same Chakra-styled component.
const ChakraSvg = chakra("svg");
const ChakraSpan = chakra("span");
const ChakraLine = chakra("line");
const ChakraPolyline = chakra("polyline");

export type CheckboxIconProps = {
    isIndeterminate?: boolean;
    isChecked?: boolean;
} & PropsOf<typeof ChakraSvg>;

export const CheckboxIcon: React.FC<CheckboxIconProps> = (props) => {
    const { isIndeterminate, isChecked, ...rest } = props;
    const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)");
    const showIndeterminate = Boolean(isIndeterminate && !isChecked);
    const isVisible = Boolean(isChecked || showIndeterminate);
    const transition = prefersReducedMotion ? "none" : "opacity 0.2s ease, transform 0.2s ease";

    return (
        <ChakraSpan
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            opacity={isVisible ? 1 : 0}
            transform={`scale(${isVisible ? 1 : 0.5})`}
            transition={transition}
        >
            <ChakraSvg
                width="1.2em"
                viewBox="0 0 24 24"
                {...rest}
                fill="none"
                stroke="currentColor"
                strokeWidth={4}
            >
                {showIndeterminate && (
                    <ChakraLine
                        x1="21"
                        x2="3"
                        y1="12"
                        y2="12"
                        transform="scaleX(1)"
                        transformOrigin="center"
                        transition={transition}
                    />
                )}
                {isChecked && (
                    <ChakraPolyline
                        points="3 12 9 18 21 2"
                        strokeDasharray={32}
                        strokeDashoffset={0}
                        transition={prefersReducedMotion ? "none" : "stroke-dashoffset 0.2s ease"}
                    />
                )}
            </ChakraSvg>
        </ChakraSpan>
    );
};
